import scroll from '@/assets/styles/scroll.module.scss';
import { useEffect, useRef } from 'react';
import Link from 'next/link';

const FeatureWorkScrollSub = ({
  workData,
  itemStyle,
  isVisibleSticky,
  t,
  lang,
}) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  // 監聽 itemStyle 變化，自動滾動到選中的項目
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const selectedItem = container.children[itemStyle] as HTMLElement;
    if (!selectedItem) return;

    // 計算滾動位置
    const containerWidth = container.offsetWidth;
    const itemLeft = selectedItem.offsetLeft;
    const itemWidth = selectedItem.offsetWidth;

    // 計算目標滾動位置
    const scrollPosition = itemLeft - containerWidth / 2 + itemWidth / 2;

    // 平滑滾動到目標位置
    container.scrollTo({
      left: scrollPosition,
      behavior: 'smooth',
    });
  }, [itemStyle]);
  return (
    <div
      className={`${
        isVisibleSticky ? 'visible opacity-100' : 'invisible opacity-0'
      } boxShadow-[0px_4px_8px_0px_#0008211A] sticky top-16 z-20 w-full max-w-[1280px] origin-top bg-white shadow-md transition-all duration-300 ease-in-out lg:top-[92px] lg:rounded-b-2xl`}
    >
      <div className="relative w-full">
        {/* 左側漸層遮罩 */}
        <div className="pointer-events-none absolute left-0 top-0 z-[1] h-full w-20 bg-gradient-to-r from-white to-transparent lg:hidden" />
        {/* 右側漸層遮罩 */}
        <div className="pointer-events-none absolute right-0 top-0 z-[1] h-full w-20 bg-gradient-to-l from-white to-transparent lg:hidden" />

        <div
          ref={scrollContainerRef}
          className={`${scroll.overflow_auto} flex w-full flex-shrink-0 snap-x snap-mandatory overflow-auto overscroll-contain px-5 lg:px-20`}
        >
          {workData.map((data, index) => (
            <div className="relative flex w-full" key={data.id}>
              <Link
                href={`/${lang}${data.href}#${data.query}`}
                className={`pointer-events-auto flex w-full cursor-pointer items-center justify-center px-[38px] py-2 md:py-5 ${
                  itemStyle === index ? 'text-gray-900' : 'text-gray-800'
                }`}
              >
                <p className="w-full whitespace-nowrap text-center">
                  {t[data.title]}
                </p>
              </Link>
              {itemStyle === index && (
                <span className="absolute bottom-0 left-0 -z-10 block h-[2px] w-full bg-gray-900" />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeatureWorkScrollSub;
